module.exports = __webpack_public_path__ + "static/media/family.9246a21b.svg";